import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url, URLS } from '@wix/da-url';

const OAuth2ClientTypeHelperText: React.FC<{}> = () => {
  const { t } = useTranslation();
  return (
    <div>
      <p>{t('deviationSubmit.form.app.oauth2ClientType.whichTypeQuestion')}</p>
      <ul>
        <li>{t('deviationSubmit.form.app.oauth2ClientType.confidentialHelp')}</li>
        <li>{t('deviationSubmit.form.app.oauth2ClientType.publicHelp')}</li>
      </ul>
      <p>
        <a href={Url.to(URLS.DEVELOPERS_AUTH)} rel="noopener noreferrer" target="_blank">
          {t('deviationSubmit.form.app.oauth2ClientType.readDocsLink')}
        </a>
      </p>
    </div>
  );
};
OAuth2ClientTypeHelperText.displayName = 'OAuth2ClientTypeHelperText';

export default OAuth2ClientTypeHelperText;
